// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.baseTreeCheckBox, .baseTreeIcon, .baseTreeCheckIcon {
    margin: 0px 4px;
}

.baseTreeNode {
    cursor: default;
    height: 40px;
}

.baseTreeNodeContent {
    flex: 1 1 auto;
    align-self: stretch;
}

.baseTreeNodeContent > * {
    align-self: center;
}

    .baseTreeNodeContent > .treeNodeCaption {
        -webkit-user-select: none;
                user-select: none;
        white-space: pre;
    }

.baseTreeNode.selectedNode > .baseTreeNodeContent {
    background-color: var(--primary-color);
}

.app-builder, .baseTreeNode.selectedNode > .baseTreeNodeContent {
    background-color: var(--appbuilder-primary-color);
    color: var(--appbuilder-hover-color);
}

.baseTreeLeafNode > .baseTreeNodeContent {
    margin-left: 24px;
}

.baseTreeIcon.dragOnIcon {
    cursor: grab
}`, "",{"version":3,"sources":["webpack://./src/app/components/common/basetreecontrol/base.tree.control.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;IAEI;QACI,yBAAiB;gBAAjB,iBAAiB;QACjB,gBAAgB;IACpB;;AAEJ;IACI,sCAAsC;AAC1C;;AAEA;IACI,iDAAiD;IACjD,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;AACJ","sourcesContent":[".baseTreeCheckBox, .baseTreeIcon, .baseTreeCheckIcon {\n    margin: 0px 4px;\n}\n\n.baseTreeNode {\n    cursor: default;\n    height: 40px;\n}\n\n.baseTreeNodeContent {\n    flex: 1 1 auto;\n    align-self: stretch;\n}\n\n.baseTreeNodeContent > * {\n    align-self: center;\n}\n\n    .baseTreeNodeContent > .treeNodeCaption {\n        user-select: none;\n        white-space: pre;\n    }\n\n.baseTreeNode.selectedNode > .baseTreeNodeContent {\n    background-color: var(--primary-color);\n}\n\n.app-builder, .baseTreeNode.selectedNode > .baseTreeNodeContent {\n    background-color: var(--appbuilder-primary-color);\n    color: var(--appbuilder-hover-color);\n}\n\n.baseTreeLeafNode > .baseTreeNodeContent {\n    margin-left: 24px;\n}\n\n.baseTreeIcon.dragOnIcon {\n    cursor: grab\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
